import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import React, { useContext, useEffect, useState, Fragment } from 'react';
import Loading from '../Statuses/Loading';
import Error from '../Statuses/Error';
import Info from '../Statuses/Info';
import { Button } from 'reactstrap';
import Swal from 'sweetalert2';
import { DepartmentContext } from '../../DepartmentWrapper';
import { fetchDataAgnostic } from '../../Services/dataApi';
import { trackInvitationView } from '../../Services/viewTracking';
import { renderCandidateNotFound } from '../../Common.functions';
import { demoInterviewDates4Portal, demoUserObject } from './demo';
import { HeaderWrapper } from './InterviewDatesWrapper.styles';
import InterviewConfirmRouter from './InterviewConfirmRouter';
import InterviewDateConfirm from './InterviewDatesSteps/InterviewDateConfirm';
import InterviewDateDecline from './InterviewDatesSteps/InterviewDateDecline';
import CandidateHeader from '../../Header/header.container';
import InterviewDateSelection from './InterviewDatesSteps/InterviewDateSelection';
import { CustomCard, CustomCardHeader, CustomCarousel, CustomCol } from './InterviewDatesWrapper.styles';
import { useLocation } from 'react-router-dom';

// Initialize Day.js plugins
dayjs.extend(utc);

const headers = [
  'Please confirm your choice to decline',
  'Select one or multiple available interview dates:',
  'Please confirm your selection:',
  `Congratulations, you've been scheduled for the following date`,
  'You have been waitlisted for the dates below',
  'You have been waitlisted for the date below',
  '-',
];
const InterviewDatesRouter = (props) => {
  const clientID = props.match.params.id;
  const [candidateHasDeclined, setCandidateHasDeclined] = useState(false);
  const [candidateMessage, setCandidateMessage] = useState('');
  const [currentSlide, setCurrentSlide] = useState(1);
  const [dateOfInterview, setDateOfInterview] = useState(false);
  const [demo, setDemo] = useState((clientID && clientID.toUpperCase() === 'DEMO') || clientID == null ? true : false);
  const [error, setError] = useState(false);
  const errorMessage = false;
  const [hasMadeSelection, setHasMadeSelection] = useState(false);
  const [hasNoChoicesToMake, setHasNoChoicesToMake] = useState(false);
  const [, setHasPermission] = useState(true);
  const [hasPreferenceOrderWithNoInterviewDate, setHasPreferenceOrderWithNoInterviewDate] = useState(false);
  const [interviewDate, setInterviewDate] = useState(null);
  const [singleDateChoice, setSingleDateChoice] = useState(false);
  const [validCandidate, setValidCandidate] = useState(true);
  const [seasonNotActive, setSeasonNotActive] = useState(false);

  const [hasInterviewDate, setHasInterviewDate] = useState(false);

  const [headerText, setHeaderText] = useState(['Select one or multiple available interview dates:']);
  const [ignoreDecline, setIgnoreDecline] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modificationConfirmed, setModificationConfirmed] = useState(false);
  const [selectedableDates, setSelectedableDates] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);

  const { listArray, user } = props;
  const { setUser, setDateList, setOrder, location, history } = props;

  const dContext = useContext(DepartmentContext);
  const query = new URLSearchParams(useLocation().search);
  const isPreview = query.get('preview');
  let hasFiredOnLoadSwal = false;

  useEffect(() => {
    if (clientID && clientID.toUpperCase() !== 'DEMO') {
                                                         // Track invitation view as soon as component loads
                                                         trackInvitationView(clientID, dContext, isPreview);

                                                         getCandidate();
                                                         getDepartmentInfo();
                                                         setDemo(false);
                                                       } else {
      Swal.fire('This is a demo!', 'Changes will not be recorded. <br> Feel free to click around.');
      setUser(demoUserObject);
      setOrder(demoInterviewDates4Portal);
      setDateList(demoInterviewDates4Portal);
      setSelectedableDates(demoInterviewDates4Portal);
      setIsLoading(false);
      // setTitle({
      //   pageTitle: 'Registration',
      //   departmentName: data.Departments4PortalName,
      //   organizationName: data.Departments4PortalOrganization,
      // });
    }
  }, [clientID, isLoading]);

  const getDepartmentInfo = () => {
    if (props && props.match && props.match.params && props.match.params.id) {
      fetchDataAgnostic('department/season/candidate/candidateId', { candidateUUID: props.match.params.id })
        .then((result) => {
          props.setUser(result.data);
        })
        .catch((err) => {
          console.error('Error in getDepartmentInfo:', err);
        });
    }
  };

  const getCandidate = (modifySelection) => {
                                              // NOTE: we're currently leaving this out of the MVP
                                              const AccessID = '123455';
                                              // const AccessID = localStorage.getItem('AccessID');

                                              setSelectedableDates([]);

                                              fetchDataAgnostic('candidate/interviewDates', {
                                                CandidateUUID: clientID,
                                                AccessID,
                                                modifySelection,
                                                pk_Season: dContext.season.pk_Season,
                                              })
                                                .then((result) => {
                                                  if (result.data)
                                                    if (
                                                      result.data &&
                                                      result.data.permission != null &&
                                                      result.data.permission === false
                                                    ) {
                                                      // if permission is false then the AccessID is invalid
                                                      localStorage.removeItem('AccessID');
                                                      return;
                                                    }

                                                  const {
                                                    hasInterviewDate,
                                                    madeChoices,
                                                    dates,
                                                    interviewDate,
                                                    declined,
                                                    candidateMessage,
                                                  } = result.data;

                                                  if (declined === true) {
                                                    setCandidateHasDeclined(true);
                                                  }
                                                  // if (permission === false) {
                                                  //   tokenCheck();
                                                  //   return;
                                                  // }
                                                  if (hasInterviewDate) {
                                                    setHasInterviewDate(true);
                                                    setInterviewDate(interviewDate);
                                                    return;
                                                  }

                                                  // Pre-calculate if we have selections to use in data transformation
                                                  // Create new array with formatted date strings to avoid non-serializable Date objects in Redux
                                                  const datesWithDateObjects = dates
                                                    .map((item, index) => ({
                                                      ...item,
                                                      DateOfInterview: item.DateOfInterview, // Keep as string for Redux serialization
                                                      // If single date choice, mark first item as selected
                                                      // If item has PreferenceOrder or preferenceOrder (0, 1, 2, etc.), it means it's selected
                                                      selected:
                                                        dates.length === 1 && !madeChoices && index === 0
                                                          ? true
                                                          : (item.PreferenceOrder !== null &&
                                                              item.PreferenceOrder !== undefined) ||
                                                            (item.preferenceOrder !== null &&
                                                              item.preferenceOrder !== undefined),
                                                      isSelected:
                                                        dates.length === 1 && !madeChoices && index === 0
                                                          ? true
                                                          : (item.PreferenceOrder !== null &&
                                                              item.PreferenceOrder !== undefined) ||
                                                            (item.preferenceOrder !== null &&
                                                              item.preferenceOrder !== undefined),
                                                      // Normalize preference fields - check both case variations
                                                      preference:
                                                        item.PreferenceOrder !== null &&
                                                        item.PreferenceOrder !== undefined
                                                          ? item.PreferenceOrder
                                                          : item.preferenceOrder,
                                                      preferenceOrder:
                                                        item.PreferenceOrder !== null &&
                                                        item.PreferenceOrder !== undefined
                                                          ? item.PreferenceOrder
                                                          : item.preferenceOrder,
                                                    }))
                                                    .sort((a, b) => {
                                                      // Fix: Check for null/undefined explicitly, not falsy values like 0
                                                      const aPreference =
                                                        a.preferenceOrder !== null && a.preferenceOrder !== undefined
                                                          ? a.preferenceOrder
                                                          : a.preference !== null && a.preference !== undefined
                                                          ? a.preference
                                                          : null;
                                                      const bPreference =
                                                        b.preferenceOrder !== null && b.preferenceOrder !== undefined
                                                          ? b.preferenceOrder
                                                          : b.preference !== null && b.preference !== undefined
                                                          ? b.preference
                                                          : null;

                                                      // Items with preferenceOrder come first, sorted by preferenceOrder (0, 1, 2, ...)
                                                      if (aPreference !== null && bPreference !== null) {
                                                        return aPreference - bPreference;
                                                      }

                                                      // Items with preferenceOrder come before items without
                                                      if (aPreference !== null && bPreference === null) return -1;
                                                      if (aPreference === null && bPreference !== null) return 1;

                                                      // Items without preferenceOrder are sorted by DateOfInterview
                                                      if (aPreference === null && bPreference === null) {
                                                        const aDate = dayjs(a.DateOfInterview);
                                                        const bDate = dayjs(b.DateOfInterview);
                                                        return aDate.isBefore(bDate)
                                                          ? -1
                                                          : aDate.isAfter(bDate)
                                                          ? 1
                                                          : 0;
                                                      }

                                                      return 0;
                                                    });

                                                  if (dates && dates.length === 1 && !madeChoices) {
                                                    setSingleDateChoice(true);
                                                    setHeaderText('The following date is available for interview');
                                                  }

                                                  if (datesWithDateObjects.length === 0) {
                                                    setHasNoChoicesToMake(true);
                                                  }
                                                  setCandidateMessage(candidateMessage);
                                                  setHasMadeSelection(madeChoices);
                                                  setOrder(datesWithDateObjects);

                                                  // if there are no dates we shouldn't ask them to pick one
                                                  if (datesWithDateObjects.length === 0) {
                                                    setHeaderText('-');
                                                  }
                                                  setDateList(datesWithDateObjects);

                                                  // Separate selected dates and prepare all dates for selection interface
                                                  // Use PreferenceOrder OR preferenceOrder to identify previously selected dates (0, 1, 2 are selected; null/undefined are not)
                                                  const selectedDatesFromAPI = datesWithDateObjects.filter(
                                                    (item) =>
                                                      (item.PreferenceOrder !== null &&
                                                        item.PreferenceOrder !== undefined) ||
                                                      (item.preferenceOrder !== null &&
                                                        item.preferenceOrder !== undefined),
                                                  );

                                                  // Set the arrays:
                                                  // - selectedDates: only the pre-selected dates (for "Thank you" page display)
                                                  // - selectedableDates: ALL dates (for selection page interface)
                                                  setSelectedDates(selectedDatesFromAPI);
                                                  setSelectedableDates(datesWithDateObjects);
                                                })
                                                .catch((err) => {
                                                  console.error('Error fetching candidate dates:', err);

                                                  if (err && err.response && err.response.status === 404) {
                                                    setValidCandidate(false);
                                                  } else if (
                                                    err &&
                                                    err.response &&
                                                    err.response.data &&
                                                    err.response.data.message === 'Season is not active'
                                                  ) {
                                                    setSeasonNotActive(true);
                                                  } else {
                                                    setError(true);
                                                  }
                                                })
                                                .finally(() => {
                                                  setIsLoading(false);
                                                });
                                            };

  // changes step.  Currently this moves it back and forth based on the num that's passed in
  const changeStep = (e, num) => {
    // if (e) e.preventDefault();

    setCurrentSlide(num);
    setHeaderText(headers[num]);
    // this scrollTo helps with very long lists
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderContent = () => {
    if (isLoading) {
      return <Loading />;
    }

    if (hasNoChoicesToMake && !hasInterviewDate) {
      const { DepartmentName } = user;
      return (
        <Info
          header={`${DepartmentName} does not currently have any dates available.`}
          subHeader={'Please contact the coordinator for additional details'}
        />
      );
    }

    return (
      <Fragment>{loadContent()}</Fragment>
    );
  };

  const ignoreDeclineFlag = (e) => {
    e.preventDefault();
    setCurrentSlide(1);
    setHasPreferenceOrderWithNoInterviewDate(false);
    setDateOfInterview(false);
    setIgnoreDecline(true);
  };

  const loadContent = () => {
    const { listArray = [], user } = props;
    const { FirstName = '', LastName = '' } = user || {};
    const firstName = FirstName;
    const lastName = LastName;

    if (!validCandidate) {
      if (!seasonNotActive) {
        return <Error header="This invitation has expired" subHeader={'Please contact your coordinator.'} />;
      }
      return renderCandidateNotFound();
    }

    if (error) {
      const header = errorMessage.header ? errorMessage.header : 'service is temporarily unavailable';
      const subHeader = errorMessage.subHeader ? errorMessage.subHeader : 'please try again later';
      return <Error header={header} subHeader={subHeader} />;
    }

    if (candidateHasDeclined && !ignoreDecline) {
      // if (false) {
      return (
        <CustomCol key={2} sm={12}>
          <CustomCard>
            {isPreview && (
              <div style={{ backgroundColor: 'var(--rr-danger-soft)', textAlign: 'center', paddingTop: 5, paddingBottom: 5 }}>
                <h5>
                  You are acting on behalf of <b>{`${lastName}${firstName && lastName ? ', ' : ''}${firstName}`}</b>.
                </h5>
              </div>
            )}

            <div
              className="alert alert-error"
              style={{
                textAlign: 'center',
                flexDirection: 'column',
                height: '40vh',
                margin: '0',
                display: 'flex',
                justifyContent: 'space-evenly',
                alignItems: 'center',
              }}
            >
              <h3 style={{ paddingBottom: '20px' }}>You have declined your invitation</h3>
              <Button onClick={(e) => ignoreDeclineFlag(e)} color="primary">
                I changed my mind...
              </Button>
            </div>
          </CustomCard>
        </CustomCol>
      );
      // will display schedule date (not needed for now)
    } else if (hasInterviewDate && interviewDate) {
      const message = `Congratulations, you're scheduled to interview on the following date`;
      return (
        <CustomCol key={2} sm={12}>
          <CustomCard>
            <CustomCardHeader>
              <h6>{message}</h6>
              {interviewDate.DateLocked && (
                <h6>Your interview date is locked in - if you need to modify it, please contact your coordinator</h6>
              )}
            </CustomCardHeader>
            {isPreview && (
              <div style={{ backgroundColor: 'var(--rr-danger-soft)', textAlign: 'center', paddingTop: 5, paddingBottom: 5 }}>
                <h5>
                  You are acting on behalf of <b>{`${lastName}${firstName && lastName ? ', ' : ''}${firstName}`}</b>.
                </h5>
              </div>
            )}
            <div
              style={{
                height: 'calc(100vh - 350px)',
                width: '100%',
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <InterviewDateConfirm
                changeStep={changeStep}
                clientID={clientID}
                dateOfInterview={interviewDate}
                getCandidate={getCandidate}
                hasMadeSelection={true}
                hasPreferenceOrderWithNoInterviewDate={hasPreferenceOrderWithNoInterviewDate}
                interviewDate={interviewDate}
                isScheduled={true}
                listArray={listArray}
                selectedDates={selectedDates}
                modificationConfirmed={modificationConfirmed}
                setHasInterviewDate={setHasInterviewDate}
                setHasNoChoicesToMake={setHasNoChoicesToMake}
                setModificationConfirmed={setModificationConfirmed}
              />
            </div>
          </CustomCard>
        </CustomCol>
      );
      // } else if (needUserInfo) {
      //   return <div />;
      //   // return <GetUserInfo />;
    } else if (hasMadeSelection) {
      return (
        <CustomCol key={2} sm={12}>
          <CustomCard>
            <CustomCardHeader>
              <h4>Thank you for your submission.</h4>
              <h6>{candidateMessage}</h6>
            </CustomCardHeader>
            {isPreview && (
              <div style={{ backgroundColor: 'var(--rr-danger-soft)', textAlign: 'center', paddingTop: 5, paddingBottom: 5 }}>
                <h5>
                  You are acting on behalf of <b>{`${lastName}${firstName && lastName ? ', ' : ''}${firstName}`}</b>.
                </h5>
              </div>
            )}
            <div
              style={{
                height: 'calc(100vh - 350px)',
                width: '100%',
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <InterviewDateConfirm
                changeStep={changeStep}
                clientID={clientID}
                demo={demo}
                getCandidate={getCandidate}
                hasMadeSelection={hasMadeSelection}
                hasPreferenceOrderWithNoInterviewDate={hasPreferenceOrderWithNoInterviewDate}
                listArray={listArray}
                selectedDates={selectedDates}
                modificationConfirmed={modificationConfirmed}
                setHasInterviewDate={setHasInterviewDate}
                setHasNoChoicesToMake={setHasNoChoicesToMake}
                setModificationConfirmed={setModificationConfirmed}
              />
            </div>
          </CustomCard>
        </CustomCol>
      );
    } else {
      return (
        <CustomCol key={2} sm={12}>
          <CustomCard>
            <CustomCardHeader>
              <h4>{headerText}</h4>
            </CustomCardHeader>
            {isPreview && (
              <div style={{ backgroundColor: 'var(--rr-danger-soft)', textAlign: 'center', paddingTop: 5, paddingBottom: 5 }}>
                <h5>
                  You are acting on behalf of <b>{`${lastName}${firstName && lastName ? ', ' : ''}${firstName}`}</b>.
                </h5>
              </div>
            )}
            {renderSwitch()}
          </CustomCard>
        </CustomCol>
      );
    }

    // <div>There's nothing here</div>
  };

  const renderSwitch = () => {
    return (
      <CustomCarousel
        className="carousel"
        showArrows={false}
        showStatus={false}
        showIndicators={false}
        showThumbs={false}
        swipeable={false}
        selectedItem={currentSlide}
      >
        <div
          id="slide1"
          style={{
            minHeight: 300,
            height: 'auto',
            // height: 'calc(100vh - 300px)',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <InterviewDateDecline changeStep={changeStep} clientID={clientID} location={location} demo={demo} />
        </div>
        <div
          id="slide2"
          style={{
            minHeight: 300,
            height: 'auto',
            // height: 'calc(100vh - 300px)',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* vet these once final decisions are made on UI */}
          <InterviewDateSelection
            changeStep={changeStep}
            hasPreferenceOrderWithNoInterviewDate={hasPreferenceOrderWithNoInterviewDate}
            selectedableDates={selectedableDates}
            selectedDates={selectedDates}
            setSelectedableDates={setSelectedableDates}
            setSelectedDates={setSelectedDates}
            singleDateChoice={singleDateChoice}
          />
        </div>

        <div
          id="slide3"
          style={{
            minHeight: 300,
            height: 'auto',
            // height: 'calc(100vh - 300px)',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* {displayOverlay ||
            (true && <div style={{ height: '100%', backgroundColor: '#000', position: 'absolute' }}></div>)} */}
          <InterviewConfirmRouter
            changeStep={changeStep}
            listArray={listArray}
            clientID={clientID}
            headerText={headerText}
            demo={demo}
            singleDateChoice={singleDateChoice}
            setHasPermission={setHasPermission}
            setHasNoChoicesToMake={setHasNoChoicesToMake}
            setHasInterviewDate={setHasInterviewDate}
            setError={setError}
            dateOfInterview={dateOfInterview}
            hasPreferenceOrderWithNoInterviewDate={hasPreferenceOrderWithNoInterviewDate}
            selectedDates={selectedDates}
          />
        </div>
      </CustomCarousel>
    );
  };

  return (
    <HeaderWrapper>
      <CandidateHeader showNotifTester={false} />
      <br />
      <br />
      <div
        onClick={(e) => {
          if (isPreview && !hasFiredOnLoadSwal) {
            const { user } = props;
            const { FirstName = '', LastName = '' } = user || {};

            e.stopPropagation();
            e.preventDefault();

            Swal.fire({
              title: 'Warning!',
              text: `You are acting on behalf of ${LastName}${FirstName && LastName ? ', ' : ''}${FirstName}.  If
                  you want to perform some actions, exit preview mode.`,
              icon: 'warning',
              confirmButtonText: 'I Understand',
              confirmButtonColor: '#d33',
              showCancelButton: true,
              cancelButtonText: 'Exit Preview Mode',
              cancelButtonColor: '#3085d6',
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.cancel) {
                // Exit preview mode: remove ?preview=true from URL
                hasFiredOnLoadSwal = true;

                // Remove the preview query parameter from the URL
                const newUrl = window.location.pathname;
                history.push(newUrl);
              }
            });
          }
        }}
      >
        {renderContent()}
      </div>
    </HeaderWrapper>
  );
};

export default InterviewDatesRouter;
